import { Box, Paper, styled } from "@mui/material";

export const TimeTrackingContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
}));

export const TimeTrackingCard = styled("form")(({ theme }) => ({
  backgroundColor: theme.palette.backgroundColor.main,
  borderRadius: theme.spacing(1),
  padding: theme.spacing(3),
  boxShadow: theme.shadows[1],
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
}));

export const PausesContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

export const PauseRow = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
  gap: theme.spacing(2),
  alignItems: "flex-end",
}));

export const TableCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));
